module.exports = __webpack_public_path__ + "static/media/entrevista.9108b26e.md";